import React, { useState, useEffect } from 'react';
import SelectColourButton from './selectColourButton';
import { Grid, Row, Col, Radio } from 'react-bootstrap';

const DEFAULT_OTHER_CONFIG = { smoothSweep: false, dateDisplayed: '', timeInWordsDisplayed: '' };

export default function AnalogClockEditModule({ eventModuleRow, updateEventModuleRow }) {
    const [webcamName, setWebcamName] = useState(eventModuleRow.name);
    const [bStyle, setBStyle] = useState(eventModuleRow.colour);
    const [other_config, setOtherConfig] = useState(
        eventModuleRow.other_config ? eventModuleRow.other_config : DEFAULT_OTHER_CONFIG
    );

    useEffect(() => {
        setWebcamName(eventModuleRow.name);
        setBStyle(eventModuleRow.colour);
        if (eventModuleRow.other_config) setOtherConfig(eventModuleRow.other_config);
    }, [eventModuleRow]);

    function notify(overrides) {
        updateEventModuleRow({
            name: webcamName,
            colour: bStyle,
            other_config,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
            ...overrides,
        });
    }

    function colourSelected(newStyle) {
        setBStyle(newStyle);
        notify({ colour: newStyle });
    }

    function handleChange(e) {
        let newConfig;
        if (e.target.name === 'dateDisplayed') {
            newConfig = { ...other_config, dateDisplayed: other_config.dateDisplayed !== '' ? '' : 'yes' };
        } else if (e.target.name === 'timeInWordsDisplayed') {
            newConfig = { ...other_config, timeInWordsDisplayed: other_config.timeInWordsDisplayed !== '' ? '' : 'yes' };
        } else if (e.target.name === 'smoothSweep') {
            newConfig = { ...other_config, smoothSweep: !other_config.smoothSweep };
        }
        setOtherConfig(newConfig);
        notify({ other_config: newConfig });
    }

    function radioButtonClicked(e) {
        const newConfig = { ...other_config, [e.target.name]: e.target.value };
        setOtherConfig(newConfig);
        notify({ other_config: newConfig });
    }

    return (
        <Grid>
            <Row>
                <Col xs={2}>Seconds Display</Col>
                <Col xs={5}>
                    <Radio name="secondsDisplay" inline value="smooth"
                        checked={other_config.secondsDisplay === 'smooth'} onChange={radioButtonClicked}>
                        Hand sweeps smoothly
                    </Radio><br />
                    <Radio name="secondsDisplay" value="precise" inline
                        checked={other_config.secondsDisplay === 'precise'} onChange={radioButtonClicked}>
                        Hand moves precisely each second
                    </Radio><br />
                    <Radio name="secondsDisplay" inline value="edge"
                        checked={other_config.secondsDisplay === 'edge'} onChange={radioButtonClicked}>
                        Displayed on edge of clock
                    </Radio><br />
                    <Radio name="secondsDisplay" value="none" inline
                        checked={other_config.secondsDisplay === 'none'} onChange={radioButtonClicked}>
                        None
                    </Radio>
                </Col>
            </Row>
            <br />
            <Row>
                <Col xs={3}>
                    <input name="dateDisplayed" style={{ marginRight: '10px' }}
                        checked={other_config.dateDisplayed !== ''}
                        onChange={handleChange} type="checkbox" value="" />
                    Display the day and date
                </Col>
            </Row>
            <Row>
                <Col xs={3}>
                    <input name="timeInWordsDisplayed" style={{ marginRight: '10px' }}
                        checked={other_config.timeInWordsDisplayed !== ''}
                        onChange={handleChange} type="checkbox" value="" />
                    Display the time in words
                </Col>
            </Row>
        </Grid>
    );
}
